module.exports = __webpack_public_path__ + "static/oAuthScreen-c5bdbad09aa5fc9fc01f1db1037a9743.png";